import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { getCheckoutSession } from "../../../api/endpoints/paymentGateway";
import type {
  CheckoutSessionRequest,
  CheckoutSessionResponse,
} from "../../../api/types/checkout";

export function useGetCheckoutSession(): UseMutationResult<
  CheckoutSessionResponse,
  Error,
  CheckoutSessionRequest,
  unknown
> {
  return useMutation<CheckoutSessionResponse, Error, CheckoutSessionRequest>({
    mutationFn: (variables: CheckoutSessionRequest) =>
      getCheckoutSession(
        variables.priceId,
        variables.sessionId,
        variables.redirectUrl
      ),
  });
}
